import baseURL from "../config/api";
import axios from "../config/axios";

export const post_BulkFamilyMemberSubGroup = async (data: any[], token: string) => {
    const response = await axios({
        url: `${baseURL}familyMemberSubGroup/CreateFamilyMemberSubGroups`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_BulkFamilyMemberSubGroup = async (data: any[], token: string) => {
    const response = await axios({
        url: `${baseURL}familyMemberSubGroup/UpdateFamilyMemberSubGroups`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const delete_BulkFamilyMemberSubGroupByFamilyMemberId = async (familyMemberId: string, userId: number, token: string) => {
    const response = await axios({
        url: `${baseURL}familyMemberSubGroup/DeleteFamilyMemberSubGroupWithFamilyMemberId/${familyMemberId},${userId}`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export const getFamilyMemberSubGroupByFamilyMemberId = (familyMemberId: string, token: string) => {
    return getFetch(`familyMemberSubGroup/GetFamilyMemberSubGroupsByFamilyMemberId/${familyMemberId}`, token);
}

const getFetch = async (url: string, token: string, params = {}) => {
    const response = await axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    });
    return response.data;
}